module.exports = __webpack_public_path__ + "static/media/YM08_1.f39e23ae.jpg";